module.exports = __webpack_public_path__ + "img/SKMG14_sticker2.58e7cee4.jpg";